import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import MenuItem from '@material-ui/core/MenuItem';
import { FormControl } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,

    },
    dialog: {
        width: '80%',
        maxHeight: 435,
    },
    MuiDialogTitle: {
        root: {
            boxSizing: 'border-box'
        }
    }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

class ServiceModal extends Component {
    state = {
        open: false,
        repair: [],
        value: '',
        isValid: false,
    };
    render() {
        const { isValid } = this.state;
        const { comment } = this.props
        return (
            <div >
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    disableBackdropClick
                    disableEscapeKeyDown
                >
                    <DialogTitle id="form-dialog-title" style={{ width: '600px' }}><i
                        className="material-icons">assignment</i> </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Залишити коментар
            </DialogContentText>
                        <TextField
                            autoFocus
                            multiline
                            rowsMax="4"
                            id="name"
                            label="Коментар"
                            type="text"
                            onChange={this.handleChangeComment}
                            fullWidth
                        />

                        {this.renderRepair()}

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Відмінити
            </Button>
                        <Button disabled={(!isValid && comment) ? true : false} onClick={this.handleSubmit} color="primary">
                            Відправити
            </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }


    // handleClickOpen = () => {
    //   this.setState({ open: true });
    // };

    handleClose = () => {
        this.props.onClose()
    };

    handleSubmit = () => {
        const { repair, value } = this.state;
        let jData = {}
        if (this.props.repair) {
            jData = {
                repair_id: repair,
                comment: value
            }
        } else if (this.props.short === 'no_repair') {
            jData = {
                repair_id: [2],
                comment: value
            }
        }
        else {
            jData = {
                comment: value
            }
        }
        this.props.submit(jData)
        this.props.onClose()

    }

    handleValidate = () => {
        const { repair, value } = this.state;
        const { comment } = this.props;
        if (!comment) {
            this.setState({
                isValid: true
            })
        }

        if (this.props.repair) {
            if (repair !== '' && value !== '') {
                this.setState({
                    isValid: true
                })
            } else {
                this.setState({
                    isValid: false
                })
            }
        } else {
            if (value !== '') {
                this.setState({
                    isValid: true
                })
            } else {
                this.setState({
                    isValid: false
                })
            }
        }
    }

    handleChangeSelect = event => {
        this.setState(
            { repair: event.target.value },
            () => this.handleValidate()
        )
    }

    handleChangeComment = (event) => {
        this.setState(
            { value: event.target.value },
            () => this.handleValidate()
        )
    }
    renderRepair = () => {
        let { repair_list } = this.props;
        if (!repair_list) {
            return null
        }
        if (this.props.repair) {
            return (<FormControl fullWidth>
                <InputLabel htmlFor="status">Тип ремонту</InputLabel>
                <Select
                    multiple
                    value={this.state.repair}
                    onChange={this.handleChangeSelect}
                    input={<Input id="status" />}
                    MenuProps={MenuProps}
                >
                    {repair_list.map((item) => {
                        return <MenuItem key={item.id} value={item.id}>
                            {item.name}
                        </MenuItem>
                    })}

                </Select>
            </FormControl>
            )
        } else {
            return null
        }
    }



}

export default withStyles(styles)(ServiceModal);


// WEBPACK FOOTER //
// ./src/components/Service/ServiceModal.js